/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {
    EventEmitter,
    Injectable
} from '@angular/core';
import {AbstractSearchCriteriaService} from '../../../shared/filter/abstract-search-criteria.service';
import {PeriodsTableColumnEnum} from '../models/periods-table-column.enum';
import {PeriodQueryModel} from '../../models/period/period-query/period-query.model';
import {PeriodSearchCriteriaModel} from '../../models/period/period-search-criteria/period-search-criteria.model';

@Injectable({
    providedIn: 'root'
})
export class PeriodsTableSearchCriteriaService extends AbstractSearchCriteriaService<PeriodsTableColumnEnum> {

    public pageSize = 7;
    public changePageEvent = new EventEmitter<void>();
    currentPeriodQuery: PeriodQueryModel;

    public getPeriodsListQuery(periodSearchCriteria: PeriodSearchCriteriaModel): PeriodQueryModel {
        const defaultCriteria = this.paginationCriteria;
        this.currentPeriodQuery = {
            paginationCriteria: {
                firstResult: defaultCriteria.firstResult,
                maxResults: defaultCriteria.maxResults
            },
            searchCriteria: periodSearchCriteria
        };
        return this.currentPeriodQuery;
    }

    clear(): void {
        // clear stored filters
        this.stateMap.clear();

        // Pagination
        this.pageSize = 7;
        this.pageNumber = 1;
        this.totalResults = 0;
    }
}
